const objectToQueryString = function(obj) {
    return Object.keys(obj).map((key) => {
        let val = obj[key];
        if (obj[key] === undefined || obj[key] === null) { val = ''; }
        return encodeURIComponent(key) + '=' + encodeURIComponent(val);
    }).join('&');
}

let baseUrl = process.env.REACT_APP_API_URL;
if (!baseUrl) {
    if (typeof window !== 'undefined' && (window.location.hostname.includes('localhost') || window.location.hostname.includes('127.0.0.1'))) {
        baseUrl = 'http://localhost:4000';
    } else {
        baseUrl = 'https://api.folksanchalan.com';
    }
}

const genericRequest = async function(options, method) {
    if (!options) return { status: false, json: { error: "No options provided" }, statusCode: 400 };
    
    try {
        const rawUrl = options.url || '';
        const normalizedUrl = rawUrl.replace('/.netlify/functions/', '/api/');
        var url = new URL(normalizedUrl, window.location.origin);
        if (options.params) {
            const searchParams = new URLSearchParams();
            for (const pKey in options.params) {
                if (Array.isArray(options.params[pKey])) {
                    for (const pVal of options.params[pKey]) {
                        searchParams.append(pKey, pVal);
                    }
                } else {
                    searchParams.append(pKey, options.params[pKey])
                }
            }
            url.search = searchParams.toString();
        }
        
        const isFormData = typeof FormData !== "undefined" && options.data instanceof FormData;
        const headers = { ...(options.headers || {}) };
        if (isFormData) {
            delete headers["content-type"];
            delete headers["Content-Type"];
        }
        if ((method === "GET" || method === "HEAD") && !options.keepContentTypeOnGet) {
            delete headers["content-type"];
            delete headers["Content-Type"];
        }

        const response = await fetch(url, {
            method: method,
            mode: 'cors',
            cache: 'no-cache',
            credentials: options.withCredentials ? 'include' : 'same-origin',
            headers,
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: method !== "GET" ? (isFormData ? options.data : JSON.stringify(options.data || {})) : undefined
        });
        
        const isJson = response.headers.get('content-type')?.includes('application/json');
        const json = isJson ? await response.json() : await response.text()
        return { 
            "statusCode": response.status, 
            "json": json,
            "status": (response.status >= 200 && response.status < 300) ? true : false 
        };
    } catch (error) {
        console.error("API Request Error:", error);
        return { 
            status: false, 
            json: { error: error.message || "Network error" }, 
            statusCode: 0 
        };
    }
}

const apiHelper = {
    "fillHeaders": (options, method) => {
        options.headers = options.headers || {};
        const isFormData = typeof FormData !== "undefined" && options.data instanceof FormData;
        if (method !== "GET" && method !== "HEAD" &&
            !isFormData &&
            !options.headers["content-type"] && !options.headers["Content-Type"]) {
            options.headers["content-type"] = 'application/json';
        }
    },
    "get": (options) => { apiHelper.fillHeaders(options, "GET");
        return genericRequest(options, "GET") },
    "post": (options) => { apiHelper.fillHeaders(options, "POST");
        return genericRequest(options, "POST") },
    "put": (options) => { apiHelper.fillHeaders(options, "PUT");
        return genericRequest(options, "PUT") },
    "patch": (options) => { apiHelper.fillHeaders(options, "PATCH");
        return genericRequest(options, "PATCH") },
    "delete": (options) => { apiHelper.fillHeaders(options, "DELETE");
        return genericRequest(options, "DELETE") }
}

export { objectToQueryString, apiHelper, baseUrl };
